import { getEnv } from 'utils/env'
import getCampaignsAndVariants, {
  SitespectVariants
} from './getCampaignsAndVariants'

export function hasActiveVariant(
  variants: SitespectVariants,
  variantIds: {
    id: number
    env: string
  }[]
) {
  return variantIds
    .filter((variant) => variant.env === getEnv('REACT_APP_ENV', true))
    .map((variantId) => variants[variantId.id])
    .filter(Boolean)
    .some((isInVariant) => isInVariant)
}

export default function isInAnyVariant(
  variantIds: {
    id: number
    env: string
  }[]
) {
  const { variants } = getCampaignsAndVariants()

  return hasActiveVariant(variants, variantIds)
}
